/* eslint-disable max-len */
import ENV from '../../../../assets/environmental.png';
import {API_ENDPOINT_JSON} from '../../../../config';

import {
  biodiversityTabQuestions,
  complianceTabQuestions,
  emissionsTabQuestions,
  energyConsumptionTabQuestions,
  materialsTabQuestions,
  supplyChainTabQuestions,
  wasteGenerationAndManagementTabQuestions,
  waterAndEffluentsTabQuestions
} from './envTabs';

export const environmental = {
  header: {
    imageUrl: ENV,
    title: 'Environmental',
    description: `Refers to a company's impact on the environment, 
      encompassing practices related to climate change, 
      resource management, and ecological sustainability.`,
    noOfModules: 10,
    answeredQuestions: 16,
    totalQuestions: 34
  },
  APIRoute: API_ENDPOINT_JSON.ESG.GRI.environmental,
  tabs: [
    {
      id: 'material',
      title: 'Material',
      questions: materialsTabQuestions
    },
    {
      id: 'energyConsumption',
      title: 'Energy Consumption',
      questions: energyConsumptionTabQuestions
    },
    {
      id: 'waterAndEffluents',
      title: 'Water And Effluents',
      questions: waterAndEffluentsTabQuestions
    },
    {
      id: 'biodiversity',
      title: 'Biodiversity',
      questions: biodiversityTabQuestions
    },
    {
      id: 'emissions',
      title: 'Emissions',
      questions: emissionsTabQuestions
    },
    {
      id: 'wasteGenerationAndManagement',
      title: 'Waste Generation & Management',
      questions: wasteGenerationAndManagementTabQuestions
    },
    {
      id: 'compliance',
      title: 'Environmental Compliance',
      questions: complianceTabQuestions
    },
    {
      id: 'supplyChain',
      title: 'Supply Chain',
      questions: supplyChainTabQuestions
    }
  ]
};
